import axios from "axios";

console.log("ambiente: ", process.env.VUE_APP_AMBIENTE);

console.log(
  "backend: ",
  process.env.VUE_APP_AMBIENTE === "PRODUCAO"
    ? process.env.VUE_APP_ZENVIA_URL_BASE
    : "http://localhost:3333"
);

const zenviaAPI = axios.create({
  baseURL:
    process.env.VUE_APP_AMBIENTE === "PRODUCAO"
      ? process.env.VUE_APP_ZENVIA_URL_BASE
      : "http://localhost:3333",
  headers: {
    "x-api-key": "38fcc451-64d1-47ec-90e8-05cbfb6b89fb",
    "Access-Control-Allow-Origin": "*",
  },
});

export default zenviaAPI;
